var escape = require("../../../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sub-header{width:100%;height:1rem;background-color:#FFFFFF;display: flex;display:-webkit-flex;align-items: center;-webkit-align-items: center;border-bottom: 1px solid #EFEFEF;position: fixed;z-index: 990;left:0;top:0;}\n.sub-header .back{width:0.8rem;height:0.8rem;background-image:url(" + escape(require("../../../images/home/goods/back.png")) + ");background-size:30%;background-repeat: no-repeat;background-position: center;}\n.sub-header .title{width:79%;height:auto;font-size:0.32rem;text-align: center;}\n.sub-header .right-btn{width:auto;height:auto;font-size:0.32rem;}", ""]);

// exports
